module.exports = __webpack_public_path__ + "assets/img/noCart.544e6135.png";